// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__Xdi0Z","options":"AnswerScale_options__1v9FV","selected":"AnswerScale_selected__3jZyI"};